<template>
    <div class="mylistwrap" v-if="isload">
        <div class="mylist" v-if="$common.basic.isarrayexist(infolist)">
            <dl class="avg listheader" v-if="!issmall">
                <dd v-if="istea">{{$common.dicword('username')}} </dd>
                <dd>{{$common.dicword('course')}}</dd>
                <dd>{{$common.dicword('startlearning')}}</dd>
                <dd>{{$common.dicword('learningtime')}}</dd>
                <dd>{{$common.dicword('learnprogress')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in infolist" :key="item.id">
                    <dd v-if="istea">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('username',true)}}&nbsp;
                        </span>
                        <ffmember :username="item.username" :stuid="item.mid"></ffmember>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('course',true)}}&nbsp;
                        </span><router-link :to="'/course/'+item.courseid">{{item.title}}</router-link>
                    </dd>

                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('startlearning',true)}}&nbsp;
                        </span>
                        {{item.datebegin}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learningtime',true)}}&nbsp;
                        </span>
                        {{item.remainsecond}}
                    </dd>
                    <dd class="progress">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('learnprogress',true)}}&nbsp;
                        </span>

                        <div class="box"><div class="past" :style="{width:item.perc+'%'}"></div></div><div class="info">{{item.perc}}</div>
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata" :small="issmall">
                </el-pagination>
            </div>
        </div>
        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>
</template>

<script>
    import { mixinsubpage } from "@/mixin/mixin"
    export default {
        name: 'Clearnprogress',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tea_my_learnprogress'
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    this.isload = true;
                    this.$common.each(res.infodatastu, item => {
                        item.title = res.infodatacourse.title;
                        let itemprogress = this.$common.basic.fffind(res.infodata, 'mid', item.id);
                        item.datebegin = '';
                        item.remainsecond = '';
                        item.perc = 0;

                        if (this.$common.basic.isobjexist(itemprogress)) {
                            item.datebegin = this.$common.basic.dateformat(itemprogress.datebegin, 'yyyy-MM-dd hh:mm');
                            item.remainsecond = this.$common.basic.chint2timewithsecond(itemprogress.remainsecond);
                            item.perc = itemprogress.perc;
                        }

                    });
                    this.infolist = res.infodatastu;
                    this.res = res;
                });
            }


        }
    }

</script>
